import React from "react";
// @material-ui/core components
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
// @material-ui/icons components

// core components
import StatsHeader from "components/Headers/StatsHeader.js";
import CardSalesValueAlternative from "components/Cards/Alternative/CardSalesValueAlternative.js";
import CardTotalOrders from "components/Cards/Charts/CardTotalOrders.js";
import CardSalesValueDots from "components/Cards/Charts/CardSalesValueDots.js";
import CardAudienceOverview from "components/Cards/Charts/CardAudienceOverview.js";
import CardAffiliateTraffic from "components/Cards/Charts/CardAffiliateTraffic.js";
import CardProductComparison from "components/Cards/Charts/CardProductComparison.js";

function Charts() {
  const theme = useTheme();
  return (
    <>
      <StatsHeader section="Charts" subsection="Charts" />
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        sx={{
          marginTop: "-6rem",
          [theme.breakpoints.up("md")]: {
            paddingLeft: "30px",
            paddingRight: "30px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column!important",
            [theme.breakpoints.up("lg")]: {
              flexDirection: "row!important",
            },
            "& .MuiCard-root": {
              marginBottom: "30px",
            },
            [theme.breakpoints.up("sm")]: {
              display: "flex",
              flexFlow: "row wrap",
              marginLeft: "-15px",
              marginRight: "-15px",
              "& .MuiCard-root": {
                flex: "1 0",
                marginRight: "15px",
                marginLeft: "15px",
                display: "flex",
                flexDirection: "column",
              },
            },
          }}
        >
          <CardSalesValueAlternative />
          <CardTotalOrders />
        </Box>
        <Grid container>
          <Grid item xs={12} xl={6}>
            <CardSalesValueDots />
          </Grid>
          <Grid item xs={12} xl={6}>
            <CardAudienceOverview />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} xl={6}>
            <CardAffiliateTraffic />
          </Grid>
          <Grid item xs={12} xl={6}>
            <CardProductComparison />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Charts;
